import { acceptHMRUpdate, defineStore } from 'pinia'

import { type TransactionMonitoringRiskConfig } from '~/types.ts'
import { useOrganization } from './organization.ts'

export const useTransactionMonitoringRiskConfig = defineStore('transactionMonitoringRiskConfig', () => {
  const organization = useOrganization()
  let hasBeenUsed = false
  const {
    data: config,
    loading,
    fetch,
  } = useFetch<TransactionMonitoringRiskConfig>(() => `transaction-monitoring-risk-configs/${organization.id}`, {
    method: 'get',
    immediate: false,
    onBeforeFetch(_, cancel, data) {
      data.value = undefined

      if (!hasBeenUsed || !organization.has_transaction_monitoring) {
        cancel()
      }
    },
  })

  async function load() {
    hasBeenUsed = true
    await fetch()
  }

  async function save(form: Partial<TransactionMonitoringRiskConfig> = {}) {
    loading.value = true

    try {
      if (config.value?.id) {
        const { data } = await api.patch(`transaction-monitoring-risk-configs/${config.value?.id}`, form)
        config.value = data
      } else {
        const { data } = await api.post('transaction-monitoring-risk-configs', { ...config.value, ...form })
        config.value = data
      }
    } finally {
      loading.value = false
    }
  }

  return {
    config,
    loading,
    load,
    save,
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTransactionMonitoringRiskConfig, import.meta.hot))
}
